import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SessionService } from '@core/services/session.service';
import { ApiBaseService } from 'eightcap-core/api/crud.service';

@Injectable({
    providedIn: 'root',
})
export class ApiHttp extends ApiBaseService {
    constructor(
        private http: HttpClient,
        private router: Router,
        private sessionService: SessionService
    ) {
        super(http);
    }

    // GET
    get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
        return this.http.get(this.basePath + path, { params: params }).pipe(
            map((res: Response) => {
                return res || {};
            }),
            catchError(this.formatErrors.bind(this))
        );
    }

    getIpAddress(
        path: string,
        headers: HttpHeaders | { [header: string]: string | string[] } = null
    ): Observable<any> {
        return this.http.get(this.basePath + path, { headers: headers }).pipe(
            map((res: Response) => {
                return res || {};
            }),
            catchError(this.formatErrors.bind(this))
        );
    }

    // POST
    post(
        path: string,
        body: any = {},
        headers: HttpHeaders | { [header: string]: string | string[] } = null
    ): Observable<any> {
        return this.http
            .post(this.basePath + path, JSON.stringify(body), {
                headers: headers,
            })
            .pipe(
                map((res: Response) => {
                    return res || null;
                }),
                catchError(this.formatErrors.bind(this))
            );
    }

    // PUT
    put(
        path: string,
        body: any = {},
        headers: HttpHeaders | { [header: string]: string | string[] } = null
    ): Observable<any> {
        return this.http
            .put(this.basePath + path, JSON.stringify(body), {
                headers: headers,
            })
            .pipe(
                map((res: Response) => {
                    return res || null;
                }),
                catchError(this.formatErrors.bind(this))
            );
    }

    // PATCH (ID ON URL)
    patch(
        path: string,
        body: any = {},
        headers: HttpHeaders | { [header: string]: string | string[] } = null
    ): Observable<any> {
        return this.http
            .patch(this.basePath + path, JSON.stringify(body), {
                headers: headers,
            })
            .pipe(
                map((res: Response) => {
                    return res || null;
                }),
                catchError(this.formatErrors.bind(this))
            );
    }

    // DELETE
    delete(path: string): Observable<any> {
        return this.http.delete(this.basePath + path).pipe(
            map((res: Response) => {
                return res || {};
            }),
            catchError(this.formatErrors.bind(this))
        );
    }

    // TODO: Separate global error handling
    private formatErrors(error: any): any {
        switch (error.status) {
            case 401:
                this.router.navigate([
                    `${this.sessionService.currentLang}` + '/auth/login',
                ]);
                break;
            case 500:
                // Do something here
                break;
            default:
        }
        return throwError(error.error);
    }
}
